import { auditApi } from './features/auth/auditApi';
import { authApi } from './features/auth/authApi';
import { dashboardKonkurrimeApi } from './features/dashboard/dashboard-konkurrimeApi';
import { detyraStudentApi } from './features/detyra/detyra-student';
import { dokumentTrajnimiApi } from './features/dokument-trajnimi/dokument-trajnimi-api';
import { evidencaApi } from './features/evidenca/evidencaApi';
import { fazaApi } from './features/fazat/fazaApi';
import { institucioniApi } from './features/institucioni/institucioni-api';
import { klasaApi } from './features/klasa/klasa-api';
import { konkurrentiApi } from './features/konkurrenti/konkurrenti';
import { verifikimeApi } from './features/konkurrenti/verifikime';
import { lendaApi } from './features/lenda/lendaApi';
import { lendeGjyqApi } from './features/lenda/lende-gjyqApi';
import { lendeVitiAkademikApi } from './features/lenda/lende-viti-akademikApi';
import { listePrezencaApi } from './features/liste-prezenca/listePrezencaApi';
import { moduliApi } from './features/moduli/moduliApi';
import { orariMesimorApi } from './features/orariMesimor/orariMesimorAPi';
import { pedagoguApi } from './features/pedagoget/pedagogetApi';
import { pjesmarresApi } from './features/pjesemarres/pjesemarres-api';
import { kontrolloPerfundimRegjistrimeApi } from './features/profili-viti-konkurrimit/kontrollo-perfundim-regjistrimeApi';
import { profili_viti_konkurrimitApi } from './features/profili-viti-konkurrimit/profili-viti-konkurrimitApi';
import { profiliApi } from './features/profili/profiliApi';
import { programeTematikeApi } from './features/program-tematik/programTematikApi';
import { rankimetApi } from './features/rankimet/rankimetApi';
import { reportsApi } from './features/reports/reportsApi';
import { studentiApi } from './features/studenti/studentiApi';
import { trajnimPrezencaApi } from './features/trajnim-prezenca/trajnim-prezenca-api';
import { trajnimetApi } from './features/trajnimet/trajnimet-api';
import { trajnuesApi } from './features/trajnues/trajnues-api';
import { universityApi } from './features/universiteti/universityApi';
import { vitiAkademikApi } from './features/vitiKonkurrimit/vitiAkademikApi';
import { vleresimeApi } from './features/vleresimi/vleresimiApi';
import { vleresimeGjyqApi } from './features/vleresimi/vleresimiGjyqApi';
import { vleresimeKlinikaApi } from './features/vleresimi/vleresimiKlinikaApi';
import { kalendarApi } from './features/calendar/calendarApi';
import { searchApi } from './features/search/search-api';
import { dashboardFFApi } from './features/dashboard/dashboard-ffApi';
import { dashboardFVApi } from './features/dashboard/dashboard-fvApi';

export const apiRegistry = [
  authApi,
  universityApi,
  profiliApi,
  profili_viti_konkurrimitApi,
  lendaApi,
  konkurrentiApi,
  verifikimeApi,
  vitiAkademikApi,
  kontrolloPerfundimRegjistrimeApi,
  fazaApi,
  trajnimetApi,
  rankimetApi,
  studentiApi,
  institucioniApi,
  pedagoguApi,
  klasaApi,
  orariMesimorApi,
  lendeVitiAkademikApi,
  pjesmarresApi,
  trajnuesApi,
  evidencaApi,
  listePrezencaApi,
  dokumentTrajnimiApi,
  vleresimeApi,
  trajnimPrezencaApi,
  detyraStudentApi,
  lendeGjyqApi,
  auditApi,
  reportsApi,
  vleresimeGjyqApi,
  vleresimeKlinikaApi,
  dashboardKonkurrimeApi,
  programeTematikeApi,
  moduliApi,
  kalendarApi,
  searchApi,
  dashboardFFApi,
  dashboardFVApi,
];
